//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    height: {
      type: String,
      default: '252px'
    },
    top: {
      type: String,
      default: '33px'
    },
    paddingTop: {
      type: String,
      default: '0'
    },
    dateList: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      moveState: false,
      overflow: 'hidden'
    };
  },
  watch: {
    moveState: function moveState(value) {
      if (value) {
        this.overflow = 'auto';
      } else {
        this.overflow = 'hidden';
      }
    }
  },
  methods: {}
};